import { defineStore } from "pinia";

interface ConfirmState {
  isVisible: boolean;
  loading: boolean;
  title: string;
  message: string;
  resolveCallback: ((value: boolean) => void) | null;
  okText: string;
  koText: string;
}

export const useConfirm = defineStore("confirm", {
  state: (): ConfirmState => ({
    isVisible: false,
    loading: false,
    title: "",
    message: "",
    resolveCallback: null,
    okText: "Conferma",
    koText: "Annulla",
  }),
  actions: {
    open(dialogTitle: string, dialogMessage: string): Promise<boolean> {
      this.title = dialogTitle;
      this.message = dialogMessage;
      this.isVisible = true;
      this.loading = false;

      return new Promise<boolean>((resolve) => {
        this.resolveCallback = resolve;
      });
    },
    confirm(): void {
      // this.isVisible = false;
      this.loading = true;
      if (this.resolveCallback) this.resolveCallback(true);
    },
    cancel(): void {
      this.isVisible = false;
      if (this.resolveCallback) this.resolveCallback(false);
    },
    close(): void {
      this.isVisible = false;
      this.loading = false;
    },
  },
  getters: {
    isDialogOpen(state): boolean {
      return state.isVisible;
    },
  },
});
